import { Pipe, PipeTransform } from '@angular/core';
import { SubSectorEnum } from '../api/model/subSectorEnum';

@Pipe({
  name: 'subSector'
})
export class SubSectorPipe implements PipeTransform {

   transform(value: SubSectorEnum | string | undefined): string {
      if (!value)
        return 'Desconhecido'
      return SubSectorEnumDescriptions[value as SubSectorEnum] || 'Desconhecido';
    }
  
  }
  
  export const SubSectorEnumDescriptions: { [key in SubSectorEnum]: string } = {
    1: "Petróleo & Gás",
    2: "Recursos Minerais",
  };